'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var File = function (_React$PureComponent) {
  _inherits(File, _React$PureComponent);

  function File() {
    _classCallCheck(this, File);

    return _possibleConstructorReturn(this, (File.__proto__ || Object.getPrototypeOf(File)).apply(this, arguments));
  }

  _createClass(File, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          icon = _props.icon;

      return _react2.default.createElement(
        'div',
        { style: { width: size, height: size + 20 }, className: 'jsx-687915046' + ' ' + 'holder'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-687915046' + ' ' + 'icon'
          },
          icon
        ),
        _react2.default.createElement(
          'svg',
          {
            width: size,
            height: size + 20,
            viewBox: '0 0 99 119',
            version: '1.1',
            xmlnsXlink: 'http://www.w3.org/1999/xlink',
            className: 'jsx-687915046'
          },
          _react2.default.createElement(
            'g',
            {
              transform: 'translate(-14.000000, -4.000000) translate(14.000000, 4.000000)',
              stroke: 'none',
              strokeWidth: 1,
              fill: 'none',
              fillRule: 'evenodd',
              className: 'jsx-687915046'
            },
            _react2.default.createElement(
              'g',
              {
                opacity: '0.15',
                transform: 'translate(0.000000, 11.483960)',
                fill: '#000',
                fillRule: 'nonzero',
                className: 'jsx-687915046'
              },
              _react2.default.createElement('path', { d: 'M86.127 30.556h-1.73V14.58c0-4.756-3.779-8.613-8.44-8.613h-5.234a5.903 5.903 0 0 0-1.972-4.148A5.665 5.665 0 0 0 64.448.411c-3.116.03-5.722 2.425-6.077 5.584h-35.48c-4.661 0-8.44 3.856-8.44 8.613v4.177H9.061A8.608 8.608 0 0 0 2.914 21.4a8.965 8.965 0 0 0-2.532 6.286v39.362-7.967a7.206 7.206 0 0 1 0-.962v9.273a2.93 2.93 0 0 1 0-.344v30.762c.08 2.714 1.41 5.23 3.588 6.79.103.35.415.594.773.603a13.527 13.527 0 0 0 7.47 2.153h73.872c6.865 0 12.422-4.306 12.422-9.474v-2.153c.022-.378.022-.756 0-1.134V43.088c-.061-6.934-5.584-12.524-12.38-12.532zm8.624 73.641a.834.834 0 0 1-.9.718.94.94 0 0 1-.45-.1c.497-.345.968-.729 1.406-1.149l-.056.531z', className: 'jsx-687915046'
              }),
              _react2.default.createElement('path', { d: 'M.48 58.118v9.273a2.93 2.93 0 0 1 0-.344V59.08a7.206 7.206 0 0 1 0-.962zm94.271 45.548v.531a.834.834 0 0 1-.9.718.94.94 0 0 1-.45-.1c.478-.347.93-.731 1.35-1.149z', className: 'jsx-687915046'
              }),
              _react2.default.createElement('path', {
                d: 'M93.4 104.815a.94.94 0 0 0 .45.1.834.834 0 0 0 .901-.718v-.53c-.42.417-.872.8-1.35 1.148z',
                opacity: '0.3',
                className: 'jsx-687915046'
              })
            ),
            _react2.default.createElement('path', {
              d: 'M98.507 103.537c0 5.24-5.627 9.474-12.436 9.474H12.214c-6.5 0-11.775-4.306-11.775-9.474V64.779c0-5.24 5.275-9.475 11.775-9.475h73.871c6.865 0 12.436 4.307 12.436 9.475l-.014 38.758z',
              fill: '#CA2',
              className: 'jsx-687915046'
            }),
            _react2.default.createElement('path', {
              d: 'M.48 63.86v9.273a2.93 2.93 0 0 1 0-.344v-7.967a7.206 7.206 0 0 1 0-.962z',
              opacity: '0.15',
              fill: '#000',
              fillRule: 'nonzero',
              className: 'jsx-687915046'
            }),
            _react2.default.createElement('path', {
              d: 'M98.564 43.074v51.505c-.024 6.957-5.549 12.588-12.366 12.604H12.256C5.594 107.02.324 101.377.48 94.58V67.391a7.54 7.54 0 0 1-.099-1.263V27.685a8.95 8.95 0 0 1 2.538-6.272 8.593 8.593 0 0 1 6.142-2.599H25.17a8.834 8.834 0 0 1 6.388 2.496 9.2 9.2 0 0 1 2.785 6.375v2.871h51.855c6.785.016 12.296 5.595 12.366 12.518z',
              fill: '#CA2',
              className: 'jsx-687915046'
            }),
            _react2.default.createElement('rect', {
              fill: '#C1C1C1',
              fillRule: 'nonzero',
              x: '14.5489068',
              y: '8.88042602',
              width: '69.8340902',
              height: '73.439922',
              rx: '5.97',
              className: 'jsx-687915046'
            }),
            _react2.default.createElement('rect', {
              fill: '#F2F2F2',
              fillRule: 'nonzero',
              x: '14.5489068',
              y: '6.00943611',
              width: '69.8340902',
              height: '73.439922',
              rx: '5.97',
              className: 'jsx-687915046'
            }),
            _react2.default.createElement('path', {
              d: 'M48.214 26.45h-18.64c-1.426 0-2.582-1.178-2.582-2.633s1.156-2.634 2.582-2.634h18.64c1.426 0 2.581 1.179 2.581 2.634 0 1.455-1.155 2.634-2.581 2.634m21.102 12.92H29.574c-1.426 0-2.582-1.18-2.582-2.635 0-1.455 1.156-2.634 2.582-2.634h39.742c1.426 0 2.582 1.18 2.582 2.634 0 1.455-1.156 2.634-2.582 2.634m0 12.934H29.574c-1.426 0-2.582-1.18-2.582-2.634 0-1.455 1.156-2.634 2.582-2.634h39.742c1.426 0 2.582 1.18 2.582 2.634 0 1.455-1.156 2.634-2.582 2.634m0 12.934H29.574c-1.426 0-2.582-1.18-2.582-2.634 0-1.455 1.156-2.634 2.582-2.634h39.742c1.426 0 2.582 1.179 2.582 2.634 0 1.455-1.156 2.634-2.582 2.634',
              fill: '#878E91',
              className: 'jsx-687915046'
            }),
            _react2.default.createElement('path', {
              d: 'M58.4 20.58V6.684C58.39 3.255 61.087.458 64.447.411a5.666 5.666 0 0 1 4.318 1.422 5.904 5.904 0 0 1 1.957 4.176h-2.575a3.24 3.24 0 0 0-1.133-2.362 3.107 3.107 0 0 0-2.482-.71 3.564 3.564 0 0 0-2.593 1.066 3.713 3.713 0 0 0-1.065 2.638v13.896c.221 1.962 1.882 3.423 3.817 3.355 1.935-.068 3.494-1.64 3.583-3.614l-.028-6.373a1.465 1.465 0 0 1 0-.187 1.454 1.454 0 0 0-.338-1.034 1.817 1.817 0 0 0-1.407-.416.986.986 0 0 0-.858.259 2.102 2.102 0 0 0-.281 1.435.952.952 0 0 1 0 .187v5.038a1.318 1.318 0 0 1-1.301 1.197c-.67 0-1.232-.517-1.302-1.197v-4.952a4.37 4.37 0 0 1 .9-3.345 3.592 3.592 0 0 1 2.814-1.134 4.272 4.272 0 0 1 3.292 1.292 3.927 3.927 0 0 1 .929 2.871l.154 6.287c.016 3.46-2.715 6.279-6.105 6.302h-.197c-3.262-.009-5.955-2.605-6.148-5.928z',
              fill: '#666',
              className: 'jsx-687915046'
            }),
            _react2.default.createElement('path', {
              d: 'M98.507 97.795c0 5.24-5.627 9.474-12.436 9.474H12.214c-6.5 0-11.775-4.306-11.775-9.474V59.037c0-5.24 5.275-9.475 11.775-9.475h73.871c6.865 0 12.436 4.307 12.436 9.475l-.014 38.758z',
              fill: '#F1C40F',
              className: 'jsx-687915046'
            }),
            _react2.default.createElement('path', {
              d: 'M94.54 61.85c-.777 0-1.407-.643-1.407-1.435-.295-2.536-2.244-4.542-4.727-4.867-.776 0-1.406-.642-1.406-1.435s.63-1.436 1.406-1.436c4.045.317 7.253 3.609 7.541 7.738 0 .792-.63 1.435-1.407 1.435z',
              fill: '#FFF',
              fillRule: 'nonzero',
              opacity: '0.5',
              className: 'jsx-687915046'
            }),
            _react2.default.createElement('path', { d: 'M52.688 54.113H82.99', fill: '#231F20', fillRule: 'nonzero', className: 'jsx-687915046'
            }),
            _react2.default.createElement('path', {
              d: 'M82.99 55.548H52.688c-.777 0-1.407-.642-1.407-1.435s.63-1.436 1.407-1.436H82.99c.777 0 1.407.643 1.407 1.436 0 .793-.63 1.435-1.407 1.435z',
              fill: '#FFF',
              fillRule: 'nonzero',
              opacity: '0.3',
              className: 'jsx-687915046'
            }),
            _react2.default.createElement('path', { d: 'M94.54 83.986V65.94', fill: '#231F20', fillRule: 'nonzero', className: 'jsx-687915046'
            }),
            _react2.default.createElement('path', {
              d: 'M94.54 85.421c-.777 0-1.407-.643-1.407-1.435V65.94c0-.792.63-1.435 1.407-1.435s1.407.643 1.407 1.435v18.045c0 .792-.63 1.435-1.407 1.435z',
              fill: '#FFF',
              fillRule: 'nonzero',
              opacity: '0.3',
              className: 'jsx-687915046'
            })
          )
        ),
        _react2.default.createElement(
          _style2.default,
          {
            id: '687915046'
          },
          ['.holder.jsx-687915046{position:relative;display:inline-block;}', '.icon.jsx-687915046{position:absolute;bottom:7%;right:5%;z-index:2;}']
        )
      );
    }
  }]);

  return File;
}(_react2.default.PureComponent);

File.defaultProps = {
  size: '24',
  icon: null
};

File.propTypes = {
  size: _propTypes2.default.number,
  icon: _propTypes2.default.node
};

exports.default = File;